import deJson from './de.json'
import enJson from './en.json'
import frJson from './fr.json'
import itJson from './it.json'
import ptBRJson from './pt-br.json'
import esJson from './es.json'

export const de = deJson
export const en = enJson
export const fr = frJson
export const it = itJson
export const ptBR = ptBRJson
export const es = esJson
